var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgVerification = function SvgVerification(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33972_48304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9826 27.244C95.5287 15.9108 81.8087 9.11446 70.1882 13.612C56.9238 18.7457 61.3218 39.8438 49.2737 44.11C42.7654 46.4146 33.1443 37.8059 26.5689 36.4857C14.4522 34.0533 3.48322 42.6027 0.782212 54.4421C-1.97338 66.5207 2.44629 82.6535 15.717 85.9318C31.5251 89.8369 39.7594 75.6264 53.0206 71.546C66.6292 67.3587 81.7605 77.2481 93.0265 65.2157C101.35 56.3263 104.393 38.4662 99.9826 27.244Z",
    fill: "#E7F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M66.702 9.32227H25.7347C23.4237 9.32227 21.5511 11.1949 21.5511 13.5059V27.2095C18.2821 28.1456 15.8887 31.1544 15.8887 34.724C15.8887 38.2936 18.2821 41.3024 21.5511 42.2386V93.6755C21.5511 95.9864 23.4237 97.8591 25.7347 97.8591H66.702C69.0129 97.8591 70.8856 95.9864 70.8856 93.6755V13.5059C70.8856 11.1947 69.0129 9.32227 66.702 9.32227Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6675 9.32227V89.4919C75.6675 91.8028 73.7949 93.6755 71.4839 93.6755H30.5166C28.2057 93.6755 26.333 91.8028 26.333 89.4919V9.32227C26.333 7.01133 28.2057 5.13867 30.5166 5.13867H71.4839C73.7949 5.13867 75.6675 7.01133 75.6675 9.32227Z",
    fill: "#B9D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.732 35.2741C33.732 39.4498 30.4568 42.8624 26.333 43.0795V27.4688C30.4568 27.6857 33.732 31.0985 33.732 35.2741Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6667 15.9381V9.32129C75.6667 7.01075 73.7937 5.1377 71.4831 5.1377H30.5166C28.2061 5.1377 26.333 7.01075 26.333 9.32129V15.9379H75.6667V15.9381Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6675 9.32129V15.9373H71.3086V9.32129C71.3086 7.01035 69.4359 5.1377 67.125 5.1377H71.4839C73.7948 5.1377 75.6675 7.01035 75.6675 9.32129Z",
    fill: "#B9D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1136 11.8679C50.7287 11.8679 51.2273 11.3693 51.2273 10.7543C51.2273 10.1392 50.7287 9.64062 50.1136 9.64062C49.4986 9.64062 49 10.1392 49 10.7543C49 11.3693 49.4986 11.8679 50.1136 11.8679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9136 39.463C30.2314 39.463 33.7316 35.9628 33.7316 31.6451C33.7316 27.3274 30.2314 23.8271 25.9136 23.8271C21.5959 23.8271 18.0957 27.3274 18.0957 31.6451C18.0957 35.9628 21.5959 39.463 25.9136 39.463Z",
    fill: "#FE8F49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4833 94.6715H61.0371C60.4871 94.6715 60.041 94.2254 60.041 93.6754C60.041 93.1253 60.4871 92.6793 61.0371 92.6793H71.4833C73.2408 92.6793 74.6708 91.2493 74.6708 89.4918V38.1836C74.6708 37.6336 75.1169 37.1875 75.6669 37.1875C76.217 37.1875 76.663 37.6336 76.663 38.1836V89.4916C76.663 92.3478 74.3395 94.6715 71.4833 94.6715Z",
    fill: "#227EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4835 4.1416H30.517C27.661 4.1416 25.3373 6.46529 25.3373 9.32129V22.852C20.7451 23.1503 17.0996 26.9788 17.0996 31.6451C17.0996 36.3114 20.7451 40.1402 25.3373 40.4383V89.4921C25.3373 92.3481 27.661 94.6718 30.517 94.6718H55.4396C55.9897 94.6718 56.4357 94.2257 56.4357 93.6757C56.4357 93.1256 55.9897 92.6796 55.4396 92.6796H30.517C28.7595 92.6796 27.3295 91.2496 27.3295 89.4921V40.3438C31.5187 39.6643 34.7277 36.0232 34.7277 31.6449C34.7277 27.2667 31.5187 23.6256 27.3295 22.9461V16.9338H74.6712V32.5859C74.6712 33.1359 75.1173 33.5819 75.6673 33.5819C76.2174 33.5819 76.6634 33.1359 76.6634 32.5859V9.32129C76.6632 6.46509 74.3397 4.1416 71.4835 4.1416ZM32.7355 31.6451C32.7355 35.4068 29.6753 38.467 25.9136 38.467C22.152 38.467 19.0918 35.4068 19.0918 31.6451C19.0918 27.8835 22.152 24.8233 25.9136 24.8233C29.6753 24.8233 32.7355 27.8835 32.7355 31.6451ZM74.671 14.9416H27.3295V9.32129C27.3295 7.56378 28.7595 6.13379 30.517 6.13379H71.4837C73.2412 6.13379 74.6712 7.56378 74.6712 9.32129V14.9416H74.671Z",
    fill: "#227EFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1729,
    y: 50.1211,
    width: 7.91379,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1729,
    y: 61.5518,
    width: 7.91379,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1729,
    y: 72.9834,
    width: 7.91379,
    height: 7.9138,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 50.1211,
    width: 7.9138,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 61.5518,
    width: 7.9138,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 72.9834,
    width: 7.9138,
    height: 7.9138,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0352,
    y: 50.1211,
    width: 7.91379,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0352,
    y: 61.5518,
    width: 7.91379,
    height: 7.91378,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0352,
    y: 72.9834,
    width: 7.91379,
    height: 7.9138,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2784 29.3884H56.4613C55.8733 29.3884 55.3965 28.9116 55.3965 28.3236C55.3965 27.7356 55.8733 27.2588 56.4613 27.2588H65.2784C65.8664 27.2588 66.3432 27.7356 66.3432 28.3236C66.3432 28.9116 65.8666 29.3884 65.2784 29.3884Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2786 33.7849H38.8753C38.2874 33.7849 37.8105 33.308 37.8105 32.7201C37.8105 32.1321 38.2874 31.6553 38.8753 31.6553H65.2786C65.8666 31.6553 66.3434 32.1321 66.3434 32.7201C66.3434 33.308 65.8668 33.7849 65.2786 33.7849Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2786 38.1813H38.8753C38.2874 38.1813 37.8105 37.7045 37.8105 37.1166C37.8105 36.5286 38.2874 36.0518 38.8753 36.0518H65.2786C65.8666 36.0518 66.3434 36.5286 66.3434 37.1166C66.3434 37.7045 65.8668 38.1813 65.2786 38.1813Z",
    fill: "#60A0FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 32,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 32,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 32,
    r: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33972_48304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVerification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/verification.c81703bc.svg";
export { ForwardRef as ReactComponent };